module.exports = __webpack_public_path__ + "assets/img/withdraw.e786c7d9.png";